import React from 'react'
import { Button, Grid, Typography } from '@mui/material'
import { LpqThanks } from '../../../icons'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(({ typography, spacing, palette }) => ({
  image: {
    marginTop: spacing(10),
    marginBottom: spacing(4)
  },
  thanksText: {
    fontWeight: typography.fontWeightMedium,
    ...typography.heading.h5,
    color: palette.common.black,
    padding: spacing(0, 5),
    marginBottom: spacing(2)
  },
  moreText: {
    ...typography.body.m,
    color: palette.common.black,
    padding: spacing(0, 3),
    marginBottom: spacing(5)
  },
  buttons: {
    '& > *:not(:last-child)': {
      marginRight: spacing(2)
    }
  },
  start: {
    width: '9em'
  }
}))

const Page1Content = props => {
  const classes = useStyles(props)
  const { onStart, onLeave } = props
  return (
    <>
      <LpqThanks className={classes.image} data-test='lpq-welcome-image' />
      <Typography
        variant='h5'
        align='center'
        className={classes.thanksText}
        data-test='lpq-welcome-thanks'
      >
        Thanks for answering the previous questions.
      </Typography>
      <Typography
        variant='body1'
        align='center'
        className={classes.moreText}
        data-test='lpq-welcome-more'
      >
        We want to know more about you. Please complete your profile answering
        some questions about yourself.
      </Typography>
      <Grid
        container
        item
        alignItems='center'
        justifyContent='center'
        className={classes.buttons}
      >
        <Button
          variant='contained'
          color='primary'
          disableElevation
          onClick={onStart}
          className={classes.start}
          data-test='lpq-welcome-start-button'
        >
          Start
        </Button>
        <Button
          variant='outlined'
          onClick={() => onLeave('do-it-later-button')}
          data-test='lpq-welcome-later-button'
        >
          Do it later
        </Button>
      </Grid>
    </>
  )
}

export default Page1Content
